import { connect } from 'react-redux'

import { showError, openModal, editRatedRecipes } from '../../store/actions'

import RecipeFeedback from './RecipeFeedback'

const mapStateToProps = ({ auth, profile, config }) => ({
  auth: {
    accessToken: auth.accessToken,
    anonymous: auth.anonymous,
  },
  profile: {
    blockedEntities: profile.blockedEntities,
  },
  config: {
    feedbackOptions: config.feedbackOptions,
  },
})

const mapDispatchToProps = { openModal, showError, editRatedRecipes }

export default connect(mapStateToProps, mapDispatchToProps)(RecipeFeedback)
